var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextSnippet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#C9CEFA",
    stroke: "#ABB2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_3613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8083 12.5H14.1667C13.25 12.5 12.5 13.25 12.5 14.1667V25.8333C12.5 26.75 13.25 27.5 14.1667 27.5H25.8333C26.75 27.5 27.5 26.75 27.5 25.8333V18.1917C27.5 17.75 27.325 17.325 27.0083 17.0167L22.9833 12.9917C22.675 12.675 22.25 12.5 21.8083 12.5ZM16.6667 22.5H23.3333C23.7917 22.5 24.1667 22.875 24.1667 23.3333C24.1667 23.7917 23.7917 24.1667 23.3333 24.1667H16.6667C16.2083 24.1667 15.8333 23.7917 15.8333 23.3333C15.8333 22.875 16.2083 22.5 16.6667 22.5ZM16.6667 19.1667H23.3333C23.7917 19.1667 24.1667 19.5417 24.1667 20C24.1667 20.4583 23.7917 20.8333 23.3333 20.8333H16.6667C16.2083 20.8333 15.8333 20.4583 15.8333 20C15.8333 19.5417 16.2083 19.1667 16.6667 19.1667ZM16.6667 15.8333H20.8333C21.2917 15.8333 21.6667 16.2083 21.6667 16.6667C21.6667 17.125 21.2917 17.5 20.8333 17.5H16.6667C16.2083 17.5 15.8333 17.125 15.8333 16.6667C15.8333 16.2083 16.2083 15.8333 16.6667 15.8333Z",
    fill: "#5F6CE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_3613"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSnippet);
export default __webpack_public_path__ + "static/media/textSnippet.f757dc3d9dfaa544780d67f702f64270.svg";
export { ForwardRef as ReactComponent };